if(window.location.href.includes('skinintegra-rapid-crack-repair-avail-welcome-offer')){
  window.location.href = 'https://skinintegra.com/products/skinintegra-rapid-crack-repair-cream-3-oz'
}
if(window.location.href.includes('skinintegra-rapid-crack-repair-buy-now')){
  window.location.href = 'https://skinintegra.com/products/skinintegra-rapid-crack-repair-cream-3-oz'
}
// if(window.location.href.includes('podiatrist')){
//   window.location.href = 'https://skinintegra.com/pages/medical-professionals'
// }
if(window.location.href.includes('receive-your-podiatrist-supplies-discount-today')){
  window.location.href = 'https://skinintegra.com/pages/medical-professionals'
}
// if(window.location.href.includes('https://skinintegra.com/collections/all')){
//   window.location.href = 'https://skinintegra.com/products/skinintegra-rapid-crack-repair-cream-3-oz'
// }
if(window.location.href.includes('https://skinintegra.com/products/essential-fatty-acid-ultra-nourishing-oil')){
  window.location.href = 'https://skinintegra.com/'
}
  if(window.location.href.includes('community')){
  window.location.href = 'https://skinintegra.com/pages/about'
}
// if(window.location.href.includes('how-it-works')){
//   window.location.href = 'https://skinintegra.com/'
// }


$(document).on("click",".swatch__option label[data-variant-option-value-label]",function() {
  setTimeout(() => {
    var value = $(".variant-selection__variants").val();
    $(".custom-product-varient-price span").removeClass("money-show");
    $(".custom-product-varient-price span[value='"+value+"']").addClass("money-show");
  }, "50");
});

if($('.product-main .faq__item')){
  $('.product-main .faq__item').click(function(){
     $(this).toggleClass('tab--open'); 
     $(this).children('section.faq__item-answer').slideToggle();
  });  
}

$(document).ready(function() {
    var parentElement = $('.top-bar-sticky').parent();
    var parentOuterHeight = parentElement.outerHeight();
    parentElement.css('height', parentOuterHeight + 'px');

    var announcementHeight = $('.announcement-sticky-wrapper').length ? $('.announcement-sticky-wrapper').outerHeight() : 0;

    $(window).scroll(function() {
        var scrollTop = $(window).scrollTop();

        if (scrollTop > announcementHeight) {
            parentElement.css({
                'position': 'fixed',
                'width': '100%',
                'z-index': '999',
                'top': announcementHeight + 'px'
            });
        } else {
            parentElement.css({
                'position': 'relative',
                'top': 'auto'
            });
        }

        var totalHeight = announcementHeight + parentOuterHeight;

        if ($('.is-sticky .header.sticky--enabled').length) {
            var stickyTop = announcementHeight > 0 ? totalHeight : parentOuterHeight;
            $('.is-sticky .header.sticky--enabled').css('top', stickyTop + 'px');
        }
    });
});

  //  StickyATC
// if($('.sticky-atc')){
//   var element_position = $('.sticky-atc').offset().top;
  
//   $(window).on('scroll', function() {
//       var y_scroll_pos = window.pageYOffset;
//       var scroll_pos_test = element_position;
//       if(y_scroll_pos > 400) {
//           $('.sticky-atc').css('top','0');
//       }else{
//           $('.sticky-atc').css('top','-100%');
//       }
//   });  
// }
